import anonymousApiClient from '@/Services/Clients/anonymousApiClient';
const VALIDATION_RULES_BASE_URL: string = 'api/validationRules';

class ValidationRulesService {

  public static getValidationRules(resourceName: string) {

    const resourceUrl = `${VALIDATION_RULES_BASE_URL}/${resourceName}`;
    return anonymousApiClient.get(resourceUrl);
  }
}

export default ValidationRulesService;
